module.exports = __webpack_public_path__ + "img/2024-15.635568fc.jpg";